import { Box, CircularProgress } from '@mui/material'

interface LoadingProps {
  size?: number
}

export const Loading = (props: LoadingProps) => {
  const { size } = props
  return (
    <Box
      style={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <CircularProgress size={size} />
    </Box>
  )
}
